export class DeleteESignReviewRequestsPayload {
   
    AgentId?: string;
    TenantId?: string;
    Action?: string = "SendContract";
    AppName?: string = "eSignature";
    RequestIds: any;
    PullAgain: boolean = false;
    Trashed: boolean = false;
    IsAutoPostContract?: boolean = false;
    Password?: string;
    AgrisSession?: string;
    UserID?: string;
}